import { dataSearchHistorySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearchHistorySolid = /*#__PURE__*/createIcon(dataSearchHistorySolid)
export default IconSearchHistorySolid
